export default "__VITE_ASSET__iNS6VvU9__"